<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-titlepage title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title case-upper">FEAR NO EVIL</h1>
<h2 class="title-page-subtitle case-upper">CHRISTIAN ROMANTIC SUSPENSE</h2>
<div class="title-page-series-info">
<p class="title-page-series-name case-upper">THE LOST ARE FOUND</p>
<p class="title-page-series-position case-upper">BOOK ONE</p>
</div>
<div class="titlepage-ornament-block titlepage-ornament-aspect-wide">
<div class="titlepage-ornament-size-container">
<img alt="" class="titlepage-ornament-image" role="presentation" src="images/heading-swash-ornate-screen.png"/>
</div>
</div>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name case-upper">REBECCA HARTT</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-wide">
<div class="title-page-publisher-logo-size-container publisher-logo-width-1000-pad-207-1000">
<img alt="Rise UP Publications" class="title-page-publisher-logo-image" src="images/riseup_logo_primary.png"/>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?34fafac8